import { AppState } from 'app-store'
import { getLocationState } from '@common/state/selectors'
import { lmiproBuyFormActions } from '@lmipro/state/buy-form/actions'
import { LmiProBuyFormData } from '@lmipro/state/buy-form/state'
import {
    getBuyFormState,
    getLabelContent,
    getCouponState,
    getPlanData,
    getCheckoutState,
} from '@lmipro/state/selectors'
import { LmiProCheckoutFormContainerState } from '@lmipro/state/checkout-form-container/state'
import { getActiveCouponServerData } from '@lmipro/utils'
import { getCurrentPlan } from '@lmipro/utils/get-current-plan'
import { LmiProPlan } from '@lmipro/state/plan'

export const mapLmiProCheckoutFormContainerState = (state: AppState): LmiProCheckoutFormContainerState => {
    const {
        errorInvalidCharacter,
        errorInvalidCVV,
        errorInvalidEmail,
        errorInvalidExpirationDate,
        errorInvalidPassword,
        errorInvalidPhoneNumber,
        errorInvalidTaxNumber,
        errorRequiredAddress,
        errorRequiredCity,
        errorRequiredFirstName,
        errorRequiredLastName,
        errorRequiredPostalCode,
        errorRequiredState,
        errorInvalidCreditCardNumber,
        emailAddressAlreadyInUse,
        errorRequiredCVV,
        errorRequiredCountry,
        errorRequiredCreditCardNumber,
        errorRequiredEmail,
        errorRequiredExpDate,
        errorRequiredPassword,
        errorRequiredPhoneNumber,
        errorInvalidPostalCode,
        errorGenericMessage,
        errorInvalidAddress,
        errorRequiredTaxNumber,
        passwordStrength,
        passwordStrengthLevel1,
        passwordStrengthLevel2,
        passwordStrengthLevel3,
        passwordStrengthLevel4,
        passwordStrengthTip1,
        passwordStrengthTip2,
        passwordStrengthTip3,
        passwordStrengthTipDrawer,
        couponDisclaimer,
    } = getLabelContent(state)
    const { selectedPlanSku } = getCheckoutState(state)
    const { initialData } = getBuyFormState(state)
    const coupon = getCouponState(state)
    const { isCouponValidAndApplied } = coupon
    const planData: LmiProPlan[] = getPlanData(state)
    const selectedPlan = getCurrentPlan(selectedPlanSku, planData)

    const couponServerData = getActiveCouponServerData(coupon, selectedPlan)
    const { locationInfo } = getLocationState(state)
    const { locale: Locale } = locationInfo

    return {
        errorContent: {
            errorInvalidCharacter,
            errorInvalidCVV,
            errorInvalidEmail,
            errorInvalidExpirationDate,
            errorInvalidPassword,
            errorInvalidPhoneNumber,
            errorInvalidTaxNumber,
            errorRequiredAddress,
            errorRequiredCity,
            errorRequiredFirstName,
            errorRequiredLastName,
            errorRequiredPostalCode,
            errorRequiredState,
            errorInvalidCreditCardNumber,
            emailAddressAlreadyInUse,
            errorRequiredCVV,
            errorRequiredCountry,
            errorRequiredCreditCardNumber,
            errorRequiredEmail,
            errorRequiredExpDate,
            errorRequiredPassword,
            errorRequiredPhoneNumber,
            errorInvalidPostalCode,
            errorGenericMessage,
            errorInvalidAddress,
            errorRequiredTaxNumber,
            passwordStrength,
            passwordStrengthLevel1,
            passwordStrengthLevel2,
            passwordStrengthLevel3,
            passwordStrengthLevel4,
            passwordStrengthTip1,
            passwordStrengthTip2,
            passwordStrengthTip3,
            passwordStrengthTipDrawer,
        },
        content: {
            couponDisclaimer,
        },
        initialData,
        isCouponValidAndApplied,
        couponServerData,
        locale: Locale,
    }
}

export const mapLmiProCheckoutFormContainerActions = {
    updateInitialFormState: (data: LmiProBuyFormData) => lmiproBuyFormActions.updateInitialFormState(data),
}
export type LmiProCheckoutFormContainerActionsType = typeof mapLmiProCheckoutFormContainerActions
